export const SexList: any = [
  {
    value: "male",
    label: "Nam",
  },
  {
    value: "female",
    label: "Nữ",
  },
];

export const StatusStudent: any = [
  {
    value: 0,
    label: "Hết hạn",
  },
  {
    value: 1,
    label: "Hoạt động",
  },
];

export const QuestionsType: any = [
  {
    value: "choose",
    label: "Từ vựng - Chọn đáp án đúng tiếng anh",
  },
  {
    value: "choose_vi",
    label: "Từ vựng - Chọn đáp án đúng tiếng việt",
  },
  {
    value: "drag_drop",
    label: "Từ vựng - Nối từ với ảnh",
  },
  // {
  //     value: "reading",
  //     label: "Đọc"
  // },
  {
    value: "filling",
    label: "Câu - Điền từ vào chỗ trống",
  },
  {
    value: "filling_drop",
    label: "Câu - Kéo thả từ vào chỗ trống",
  },
  // {
  //     value: "filling_select",
  //     label: "Chọn từ vào chỗ trống"
  // },
  {
    value: "arrange",
    label: "Câu - Sắp xếp câu",
  },
];

export const StatusList: any = [
  {
    value: 0,
    label: "Ngưng",
  },
  {
    value: 1,
    label: "Hoạt động",
  },
];

export const PackagesType: any = [
  {
    value: "personal",
    label: "Cá nhân",
  },
  {
    value: "family",
    label: "Gia đình",
  },
  {
    value: "economy",
    label: "Economy",
  },
];
export const PackagesPersonalType: any = [
  {
    value: "basic",
    label: "Cơ bản",
  },
  {
    value: "pro",
    label: "Pro",
  },
  {
    value: "economy",
    label: "Economy",
  },
];
export const PackagesFamilyType: any = [
  {
    value: "pro",
    label: "Pro",
  },
  {
    value: "vip",
    label: "Vip",
  },
];

export const WordLevel: any = [
  {
    value: "A1",
    label: "A1",
  },
  {
    value: "A1+",
    label: "A1+",
  },
  {
    value: "A2",
    label: "A2",
  },
  {
    value: "A2+",
    label: "A2+",
  },
  {
    value: "B1",
    label: "B1",
  },
  {
    value: "B1+",
    label: "B1+",
  },
  {
    value: "B2",
    label: "B2",
  },
  {
    value: "B2+",
    label: "B2+",
  },
  {
    value: "C1",
    label: "C1",
  },
  {
    value: "C1+",
    label: "C1+",
  },
  {
    value: "C2",
    label: "C2",
  },
  {
    value: "C2+",
    label: "C2+",
  },
];

export const SentenceLevel: any = [
  {
    value: "basic",
    label: "Basic",
  },
  {
    value: "lowIntermediate",
    label: "Low-intermediate",
  },
  {
    value: "preIntermediate",
    label: "Pre-intermediate",
  },
  {
    value: "intermediate",
    label: "Intermediate",
  },
  {
    value: "advanced",
    label: "Advanced",
  },
  {
    value: "expert",
    label: "Expert",
  },
];

export const MarkType: any = [
  {
    value: "plus",
    label: "Plus (+)",
  },
  {
    value: "equal",
    label: "Equal (=)",
  },
  {
    value: "vs",
    label: "Vs (vs)",
  },
  {
    value: "and",
    label: "And (&)",
  },
];

export const SettingSunEditor: any = {
  buttonList: [
    ["undo", "redo"],
    ["font", "fontSize", "formatBlock"],
    ["paragraphStyle", "blockquote"],
    ["bold", "underline", "italic", "strike", "subscript", "superscript"],
    ["fontColor", "hiliteColor", "textStyle"],
    ["removeFormat"],
    ["outdent", "indent"],
    ["align", "horizontalRule", "list", "lineHeight"],
    // ["link", "image"],
    ["fullScreen", "showBlocks", "codeView"],
    ["preview", "print"],
    ["save", "template"],
  ],
};

export const ContractList = [
  {
    value: "chinh_thuc",
    label: "Chính thức",
  },
  {
    value: "thu_viec",
    label: "Thử việc",
  },
  {
    value: "ctv",
    label: "Cộng tác viên",
  },
];

export const PositionList = [
  {
    value: "quan_ly",
    label: "Quản lý",
  },
  {
    value: "nhan_vien",
    label: "Nhân viên",
  },
  {
    value: "ctv",
    label: "Cộng tác viên",
  },
];

export const LanguagesTab = [
  {
    value: "vi",
    label: "Tiếng Việt",
  },
  {
    value: "en",
    label: "Tiếng Anh",
  },
];

export const MenuPages = [
  {
    id: "home",
    title: "Trang chủ",
    slug: "/",
  },
  {
    id: "about",
    title: "Trang giới thiệu",
    slug: "about-us",
  },
  {
    id: "news",
    title: "Trang tin tức",
    slug: "tin-tuc",
  },
];
